import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {sdoNs} from '../constants-enumerate';
import {storeInstance} from '@aofl/store/dist/legacy';
import {mapStatePropertiesMixin} from '@aofl/map-state-properties-mixin';

/**
 * @summary PdfTemplate
 * @extends {AoflElement}
 */
@customElement('pdf-template')
class PdfTemplate extends mapStatePropertiesMixin(AoflElement) {
  /**
   * Creates an instance of PdfTemplate.
   */
  constructor() {
    super();
    this.storeInstance = storeInstance;
  }

  @property({type: Object, mapState: `${sdoNs.SESSION}.group_info`, store: storeInstance})
  groupInfo = {};

  @property({type: String})
  product = '';

  @property({type: Boolean, mapState: `${sdoNs.SESSION}.loggedIn`, store: storeInstance})
  loggedIn = false;

  /**
   * @readonly
   */
  static is = 'pdf-template';

  connectedCallback() {
    super.connectedCallback();
  }

  mapStateProperties() {
    const url = new URL(location.href);
    this.product = decodeURIComponent(url.searchParams.get('product'));
  }


  /**
   *
   * @return {Object}
   */
  render() {
    return super.render(template, [styles]);
  }
}

export default PdfTemplate;
